export interface Config {
  getSync(
    key: string,
    defaultValue: string | number | boolean
  ): string | number | boolean;
}
